enum NavigationShowIn {
  Both = 0,
  Mobile = 1,
  Desktop = 2,
}

export default NavigationShowIn;
